import { type InputCapture } from '@canvas/input';

import { type MouseState } from './state-machine/mouse-state-machine';

export interface EventLoop {
  start(): void;
  stop(): void;
}

export function createEventLoop(
  inputCapture: InputCapture,
  initialState: MouseState
): EventLoop {
  let currentState: MouseState = initialState;
  let frameId: number | null = null;

  function processFrame() {
    const events = inputCapture.getEvents();

    for (const event of events) {
      if (event.type === 'pointerDown') {
        currentState = currentState.onPointerDown(event);
      } else if (event.type === 'pointerMove') {
        currentState = currentState.onPointerMove(event);
      } else if (event.type === 'pointerUp') {
        currentState = currentState.onPointerUp(event);
      }
    }

    inputCapture.clear();
    frameId = requestAnimationFrame(processFrame);
  }

  return {
    start() {
      if (frameId !== null) {
        return;
      }
      frameId = requestAnimationFrame(processFrame);
    },
    stop() {
      if (frameId !== null) {
        cancelAnimationFrame(frameId);
        frameId = null;
      }
    },
  };
}
